/* 设置系统变量，用户通过window.SessionGloabalVariable = {xxx: xxx} 传入修改变量 */

export interface IVariablType {
    NODE_ENV: string
    API_BASE_URL: string
    API_LOGIN_URL: string
    MAIN_URL: string
    GET_TOKEN_URL: string
    MIAN_APP_ID: string
    WX_APP_ID: string
    COMPONENT_APP_ID: string
    LOGIN_URL: string
    AUTHORIZATION_URL: string
    WPK_ACC_ID: number
}

const defaultVariable = {
    NODE_ENV: 'production',
    API_BASE_URL: 'https://api.goweike.net',
    API_LOGIN_URL: 'https://login.goweike.net',
    MAIN_URL: `https://${location.hostname.split('.')[0]}.weike.goweike.net`,
    GET_TOKEN_URL: '/login/access_token',
    MIAN_APP_ID: 'wx0f29dc0c9a3f2765',
    WX_APP_ID: location.hostname.split('.')[0],
    COMPONENT_APP_ID: 'wxbd2ff27a2c153c16',
    LOGIN_URL: '/login/mp_auth_1',
    AUTHORIZATION_URL: `https://open.weixin.qq.com/connect/oauth2/authorize`,
    WPK_ACC_ID: -1
}

const reg = new RegExp('(^|&)wpk_acc_id=([^&]*)(&|$)', 'i')
const wpkAccId = location.search.substr(1).match(reg)

// 需要添加配置的列表
const hostList = {
    // 测试域名
    host1: ['weike.yiqishequn.com', 'localhost', 'dev.goweike.net', 'wkbfe.yiqishequn.com', 'test.cywktec.cn'],
    // 新域名
    host2: ['jingxinclass.com'],
    // 特例测试域名
    host3: ['sz.bztwk.cn']
}

// 检测列表中域名是否跟当前域名匹配
const checkHostList = (hostList: string[]) => hostList.filter(val => location.hostname.indexOf(val) > -1).length > 0

if (checkHostList(hostList.host1)) {
    // 测试域名要改一下配置
    defaultVariable.API_BASE_URL = 'https://api.yiqishequn.com'
    defaultVariable.API_LOGIN_URL = 'https://login.yiqishequn.com'
    defaultVariable.MAIN_URL = `https://${location.hostname.split('.')[0]}.weike.yiqishequn.com`
    defaultVariable.MIAN_APP_ID = 'wxdb28376af47c59e1'
    defaultVariable.WX_APP_ID = location.hostname.split('.')[0]
    defaultVariable.COMPONENT_APP_ID = 'wxf3eccd9684cff750'
    defaultVariable.WPK_ACC_ID = wpkAccId ? +wpkAccId[2] : -1
    const search = wpkAccId ? `wpk_acc_id=${wpkAccId[2]}&` : '' + `bappid=${defaultVariable.WX_APP_ID}`
    defaultVariable.GET_TOKEN_URL =  `/login/access_token?${search}`
} else if (checkHostList(hostList.host2)) {
    // 新域名
    defaultVariable.API_BASE_URL = 'https://api.jingxinclass.com'
    defaultVariable.API_LOGIN_URL = 'https://login.jingxinclass.com'
    defaultVariable.MAIN_URL = `https://${location.hostname.split('.')[0]}.weike.jingxinclass.com`
} else if (checkHostList(hostList.host3)) {
    // 新登录域名（用于兜底）
    defaultVariable.API_LOGIN_URL = 'https://login.lpclass.cn'
} else if (location.hostname.indexOf("goweike.net") == -1) {
    // 新域名
    defaultVariable.API_LOGIN_URL = "https://login.jingxinclass.com";
}

// alert('WX_APP_ID:' + defaultVariable.WX_APP_ID)
// alert('API_LOGIN_URL:' + defaultVariable.API_LOGIN_URL)

declare const window: Window & { SessionGlobalVariable: {
        NODE_ENV?: string
        API_BASE_URL?: string
        API_LOGIN_URL?: string
        MAIN_URL?: string
        GET_TOKEN_URL?: string
        MIAN_APP_ID: string
        WX_APP_ID?: string
        COMPONENT_APP_ID?: string
        LOGIN_URL?: string
        AUTHORIZATION_URL?: string
        WPK_ACC_ID?: number
    }
}

class Variable {
    public GlobalVariable: IVariablType = defaultVariable
    constructor() {
        this.initVariable()
    }
    public initVariable() {
        const userConf = {
            ...window.SessionGlobalVariable
        }
        this.GlobalVariable = {
            ...defaultVariable,
            ...userConf
        }
    }
}

export default Variable
